

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck  } from '@shared/models';
	import CompanyBrandImage from '@client/views/industry/companies/CompanyBrandImage.vue';
	import ProItem from '@client/views/industry/pros/ProItem.vue';

	@Component({
		components: {
			CompanyBrandImage,
			ProItem,
		},
	})
	export default class DeckSideInfo extends BaseView {

		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;

	}
	
